import axios from 'axios';
import store from '../../store/index';

export default {
	load(showDeleted, limit, offset) {
		return axios.get(`${store.state.tenant.tenant?.name}/api/adapterruns?deleted=${showDeleted}&limit=${limit}&offset=${offset}`, {
			headers: {
				Authorization: `Bearer ${store.state.auth.token}`,
			},
		});
	},
	editAdapterLog(adapterLog) {
		return axios.patch(`${store.state.tenant.tenant?.name}/api/adapterruns/${adapterLog.id}`, adapterLog, {
			headers: {
				Authorization: `Bearer ${store.state.auth.token}`,
			},
		});
	},
	deleteAdapterLog(adapterLog) {
		return axios.delete(`${store.state.tenant.tenant?.name}/api/adapterruns/${adapterLog.id}`, {
			headers: {
				Authorization: `Bearer ${store.state.auth.token}`,
			},
		});
	},
	findAdapterRun(id) {
		return axios.get(`${store.state.tenant.tenant?.name}/api/adapterruns/${id}`, {
			headers: {
				Authorization: `Bearer ${store.state.auth.token}`,
			},
		});
	},
};
